module.exports = __webpack_public_path__ + "static/media/Group 47.ccc3ed7b.svg";